import React, { useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";
import { MdArrowCircleUp, MdOutlineUnsubscribe } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import logo from "../../../../images/logo.png";
import "./Footer.css";

export default function Footer() {
  const [formData, setFormData] = useState({ email: "", error: false });
  const year = new Date().getFullYear();

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const socialLinks = [
    {
      href: "https://www.facebook.com/eBenchAI",
      icon: <FaFacebookF />,
      color: "#1877F2",
    },
    {
      href: "https://www.instagram.com/ebench.ai/",
      icon: <FaInstagram />,
      color: "#E1306C",
    },
    {
      href: "https://www.linkedin.com/company/ebench-ai/",
      icon: <FaLinkedinIn />,
      color: "#0A66C2",
    },
    { href: "https://x.com/eBenchAI", icon: <FaXTwitter />, color: "#1DA1F2" },
  ];

  const quickLinks = {
    Solutions: [
      { label: "Vendor Management", path: "/",},
      { label: "Candidate Screening", path: "/", },
      {
        label: "Interview Automation",
        // path: "/solutions/interview-automation",
        path: "/",
      },
      { label: "AI Talent Match", path: "/" },
    ],
    Products: [
      { label: "AI Talent Match", path: "/" },
      { label: "Smart Dashboard", path: "/" },
      { label: "Analytics Reports", path: "/" },
    ],
    Company: [
      { label: "About Us", path: "/about-us" },
      { label: "Contact", path: "/contact-us" },
      { label: "Careers", path: "/careers" },
    ],
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column first-column">
          <img src={logo} alt="Ebench.ai Logo" className="footer-logo" />
          <p className="footer-text">
            Ebench.ai transforms hiring with AI-powered solutions, analytics,
            and automation for smarter talent acquisition.
          </p>
          <p className="footer-text">
            Optimize recruitment workflows, enhance candidate experiences, and
            discover top talent faster with our innovative platform.
          </p>
          <div className="footer-social">
            {socialLinks.map((link, idx) => (
              <a
                key={idx}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ backgroundColor: link.color }}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        {Object.keys(quickLinks).map((section, idx) => (
          <div className="footer-column" key={idx}>
            <h4 className="footer-heading">{section}</h4>
            <ul className="footer-links">
              {quickLinks[section].map((item, i) => (
                <li key={i}>
                  <Link to={item.path} className="footer-link">
                    <IoIosArrowForward className="link-icon" /> {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Newsletter */}
        <div className="footer-column">
          <h4 className="footer-heading">NEWSLETTER</h4>
          <p className="footer-text">
            Subscribe for the latest AI recruitment insights and platform
            updates.
          </p>
          <div className="newsletter-wrapper">
            <div className="newsletter">
              <input
                type="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                    error: false,
                  })
                }
                className={
                  formData.error ? "newsletter-input error" : "newsletter-input"
                }
              />
              <button
                className="newsletter-btn"
                onClick={() => {
                  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!formData.email || !emailPattern.test(formData.email)) {
                    setFormData({ ...formData, error: true });
                  } else {
                    setFormData({ email: "", error: false });
                    alert("Subscribed successfully!");
                  }
                }}
              >
                <MdOutlineUnsubscribe size={20} /> Subscribe
              </button>
            </div>
            {formData.error && (
              <p className="error-text">Please enter a valid email address</p>
            )}
          </div>
        </div>
      </div>

      <button className="scroll-top" onClick={scrollToTop}>
        <MdArrowCircleUp size={32} />
      </button>

      <div className="footer-bottom">
        <p>
          © {year} Ebench.ai. All rights reserved.{" "}
          <Link to="/">Privacy Policy</Link> |{" "}
          <Link to="/">Terms & Conditions</Link>
        </p>
      </div>
    </footer>
  );
}
